"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_native_1 = require("react-native");
var FlashList_1 = require("./FlashList");
// Typecast as required
var AnimatedFlashList = react_native_1.Animated.createAnimatedComponent(FlashList_1.FlashList);
exports.default = AnimatedFlashList;
//# sourceMappingURL=AnimatedFlashList.js.map